<template>
  <div class="containerBox">
    <div id="myCarousel" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
        <li data-target="#myCarousel" data-slide-to="1"></li>
        <li data-target="#myCarousel" data-slide-to="2"></li>
        <li data-target="#myCarousel" data-slide-to="3"></li>
        <li data-target="#myCarousel" data-slide-to="4"></li>
      </ol>

      <div class="carousel-inner">
        <div class="item active">
          <div class="ItemContent">
            <h1>{{ Slide1.heading }}</h1>
            <p>
              {{ Slide1.description }}
            </p>
          </div>
        </div>

        <div class="item">
          <div class="ItemContent">
            <h1>{{ Slide2.heading }}</h1>
            <p>
              {{ Slide2.description }}
            </p>
          </div>
        </div>

        <div class="item">
          <div class="ItemContent">
            <h1>{{ Slide3.heading }}</h1>
            <p>
              {{ Slide3.description }}
            </p>
          </div>
        </div>
        <div class="item">
          <div class="ItemContent">
            <h1>{{ Slide4.heading }}</h1>
            <p>
              {{ Slide4.description }}
            </p>
          </div>
        </div>
        <div class="item">
          <div class="ItemContent">
            <h1>{{ Slide5.heading }}</h1>
            <p>
              {{ Slide5.description }}
            </p>
          </div>
        </div>
      </div>

      <a class="left carousel-control" href="#myCarousel" data-slide="prev">
      </a>
      <a class="right carousel-control" href="#myCarousel" data-slide="next">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slides",
  data() {
    return {
      Slide1: {
        heading: "In every 10 households",
        description: "7 households have a child who needs milk everyday.",
      },
      Slide2: {
        heading: "In every 10 households",
        description: "7 households have a child who needs milk everyday.",
      },
      Slide3: {
        heading: "In every 10 households",
        description: "7 households have a child who needs milk everyday.",
      },
      Slide4: {
        heading: "In every 10 households",
        description: "7 households have a child who needs milk everyday.",
      },
      Slide5: {
        heading: "In every 10 households",
        description: "7 households have a child who needs milk everyday.",
      },
    };
  },
};
</script>

<style scoped>
.carousel-control {
  opacity: unset;
  background-image: none;
  position: absolute;
  top: 40%;
}
.glyphicon {
  margin-top: 60px;
  color: #32bad4;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 50px;
  box-shadow: none;
}
.item {
  line-height: 30px;
  text-align: center;
  margin: auto;
}
.item .ItemContent {
  display: grid;
  place-items: center;
  border-radius: 15px;
  color: #fff;
  background-color: #0077b6;
  width: 800px;
  margin: auto;
  padding-bottom: 50px;
}
.item h1 {
  font-family: "DM Sans";
  font-size: 46px;
  font-weight: 700;
  line-height: 60px;
  text-align: center;
}
.item p {
  margin: auto;
  width: 90%;
  color: #fff;
  font-family: "DM Sans";
  font-size: 26px;
  line-height: 34px;
  text-align: center;
}
.containerBox {
  display: grid;
  place-items: center;
  height: 270px;
  background-color: #0077b6;
  margin: 100px auto 100px auto;
}
.carousel-inner {
  width: 100%;
  margin: auto;
}

.carousel-indicators li {
  position: relative;
  top: 50px;
  width: 20px;
  height: 5px;
  margin: 5px;
  text-indent: 0;
  border: none;
  border-radius: 10px;
  background-color: #ffffff60;
  transition: 200ms;
  transition-timing-function: ease-in-out;
}
.carousel-indicators .active {
  width: 20px;
  height: 5px;
  background-color: #fff;
}
@media screen and (max-width: 720px) {
  .item .ItemContent {
    width: 100%;
  }
  .item h1 {
    font-size: 20px;
    font-weight: 700;
    line-height: 21px;
    text-align: center;
  }

  .item p {
    color: #fff;
    font-size: 15px;
    letter-spacing: 1px;
    line-height: 20px;
    text-align: center;
  }
}
</style>